import { useNavigate } from "react-router-dom"
import useTargetStorage from "@/hooks/useTargetStorage"
import EditStorageForm from "features/storages/editStorageForm"
import Callout from "components/callout/callout"
import { useTranslation } from "react-i18next"
import Section from "components/layout/section"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import PageTitle from "features/navigation/pageTitle"
import useStorages from "@/hooks/useStorages"
import useAccess from "@/hooks/useAccess"
import { AccessRole } from "@/types"
import { paramGuardStorage } from "@/utils/paramGuard"
import RightSidebar from "@/components/sidebar/right/RightSidebar"

const EditStoragePage = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()

    // Get ID from URL.
    const { targetStorageDocId: storageId } = useTargetStorage()
    const { 
        storage,
        storageStatus
    } = useStorages({ storageId })
    // Check params and declare safe ones to use in JSX
    if (!paramGuardStorage({storageId, storage, storageStatus, navigate})) {
        return <></>
    }
    const safeStorageId = storageId!;

    // Only OWNER can access this page
    const { limitToRoles } = useAccess({ storageId: safeStorageId })
    const isOwner = limitToRoles([AccessRole.OWNER])
    if (!isOwner) {
        return <Callout type="error">{t('errorOnlyOwnerCanEditStorage')}</Callout>
    }
    return (
        <>
            <PageTitle title={t('titleEditStorage')} />
            <Section>
                <EditStorageForm storageId={safeStorageId} />
            </Section>
        </>
    )
}

export default EditStoragePage

